import React  from 'react';  

export const reviewsRatingsConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        path: '/review-ratings',
        component: React.lazy(() => import('./Recommendations')),
      },
    ],
  },
 
];